import FetchRequest from "@/api/FetchRequest";

class MessageApi {
  static url = "/api/sys/messages";

  static list(chatId: string, fromId: string, type: string, pageSize: number) {
    const param =
      "?chatId=" +
      chatId +
      "&fromId=" +
      fromId +
      "&type=" +
      type +
      "&pageSize=" +
      pageSize;
    return FetchRequest.get(this.url + param, true);
  }

  static page(
    chatId: string,
    fromId: string,
    type: string,
    messageType: string,
    current: number,
    size: number
  ) {
    const param =
      "?chatId=" +
      chatId +
      "&fromId=" +
      fromId +
      "&chatType=" +
      type +
      "&messageType=" +
      messageType +
      "&current=" +
      current +
      "&size=" +
      size;
    return FetchRequest.get(this.url + "/page" + param, true);
  }
// 删除消息(单条)
static Delemessage(id:string): Promise<any> {
      
  return FetchRequest.del(this.url+'/message/' +id,'' ,true);
}
// 刷新消息(单条)
static reputmessage(id:string): Promise<any> {
      
  return FetchRequest.put(this.url+'/refresh/' +id,'' ,true);
}
// 删除消息(单条)
static DelemessageAll(id:string): Promise<any> {
      
  return FetchRequest.del(this.url+'/chat/' +id,'' ,true);
}

}

export default MessageApi;
